module.exports = __webpack_public_path__ + "static/media/pic1.577e43b0.jpg";